import React from "react";

import { useHistory, generatePath, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAdmin } from "../providers/AdminProvider/AdminProvider";
import { useFlags } from "launchdarkly-react-client-sdk";

import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/cjs/Nav";
import NavDropdown from "react-bootstrap/cjs/NavDropdown";
import NavbarLink from "../components/NavbarLink/NavbarLink";
import NavDropdownItem from "../components/NavDropdownItem/NavDropdownItem";
import Form from "react-bootstrap/cjs/Form";
import FormControl from "react-bootstrap/cjs/FormControl";
import Button from "react-bootstrap/cjs/Button";

import * as routes from "routes";

const Navigation = () => {
  const { search } = useLocation();
  const history = useHistory();
  const { ilx76 } = useFlags();

  const searchParams = new URLSearchParams(search);

  const { register, handleSubmit } = useForm({
    defaultValues: {
      search: searchParams.get("search") ?? "",
    },
  });

  const { globalAdmin } = useAdmin();

  const onSearch = (data) => {
    const params = new URLSearchParams({ search: data.search });
    history.push({
      pathname: "/search",
      search: `?${params}`,
    });
  };

  return (
    <Navbar bg={"dark"} variant={"dark"}>
      <Navbar.Toggle aria-controls={"nav"} />
      <Navbar.Collapse className={"navbar-nav"} id={"nav"}>
        <Nav className={"mr-auto"}>
          <NavbarLink exact to={"/"}>
            Home
          </NavbarLink>
          <NavbarLink exact to={routes.PORTALS}>
            Portals
          </NavbarLink>
          {globalAdmin && (
            <>
              <NavDropdown id={"create"} title={"Create Portal"}>
                <NavDropdownItem
                  exact
                  to={generatePath(routes.CREATE_PORTAL, {
                    licensed: "licensed",
                  })}
                >
                  Create Best Practice Portal (licensed)
                </NavDropdownItem>
                <NavDropdownItem exact to={generatePath(routes.CREATE_PORTAL)}>
                  Create Best Practice Portal
                </NavDropdownItem>
              </NavDropdown>
              <NavDropdown id={"administrators"} title={"Administrators"}>
                <NavDropdownItem exact to={routes.ADMINISTRATORS}>
                  List
                </NavDropdownItem>
                <NavDropdownItem exact to={routes.ADD_ADMINISTRATOR}>
                  Add
                </NavDropdownItem>
              </NavDropdown>
              <NavDropdown id={"configure"} title={"Configure"}>
                <NavDropdownItem exact to={generatePath(routes.CONFIGURE_CUSTOMITEMS)}>
                  Customisable Global Items
                </NavDropdownItem>
                <NavDropdownItem exact to={"/configure/resources"}>
                  Resources
                </NavDropdownItem>
              </NavDropdown>
              <NavDropdown id={"lms"} title={"LMS Clients"}>
                <NavDropdownItem exact to={routes.LMS_CLIENTS}>
                  List
                </NavDropdownItem>
                <NavDropdownItem exact to={routes.LMS_ADD_CLIENT}>
                  Add
                </NavDropdownItem>
              </NavDropdown>

              {ilx76 ? (
                <NavbarLink exact to={routes.COURSES}>
                  Courses
                </NavbarLink>
              ) : null}
            </>
          )}
        </Nav>
        <Form inline onSubmit={handleSubmit(onSearch)}>
          <FormControl
            name={"search"}
            type={"text"}
            placeholder={"Search"}
            className={"mr-sm-2"}
            ref={register}
          />
          <Button variant={"light"} type={"submit"}>
            Search
          </Button>
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navigation;
